import type { PropsWithChildren, ReactNode } from 'react'

interface TableContainerProps extends PropsWithChildren {
  /** Optional banner/alert component to show above the table */
  banner?: ReactNode
  /** Sheet component to render in the side sheet area */
  sheet?: ReactNode
  /** Additional className for the outer container */
  className?: string
}

/**
 * Reusable container for tables with consistent layout structure.
 * Provides the common div structure used across table pages.
 */
export const TableContainer = ({
  children,
  banner,
  sheet,
  className = 'pb-2 h-full overflow-hidden flex flex-col',
}: TableContainerProps) => (
  <div className={className}>
    <div className="table-layout flex flex-col flex-1 min-h-0">
      {banner}
      {children}
    </div>
    {sheet && <div id="side-sheet">{sheet}</div>}
  </div>
)
